import { useState } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";

import { Car } from "./components/car";
import { CarList } from "./components/car-list";
import { ContactForm } from "./components/contactForm";
import { ContextProvider } from "./context";
import { Filter } from "./components/filter";
import { Footer } from "./components/footer";
import { Menu } from "./components/menu";
import { Reviews } from "./components/reviews";
import { Services } from "./components/services";
import { Welcome } from "./components/welcome";

import "./App.css";
import { cars } from "./data/cars";

export const App = () => {
  const [filters, setFilters] = useState<{ [key: string]: boolean }>({});

  const nothingSelected = Object.values(filters).every((value) => !value);
  const onlyCabrioletsSelected = Object.entries(filters).every(
    ([key, value]) => !value || (key === "cabrio" && value),
  );

  const filteredCars = cars.filter((car) => {
    if (nothingSelected) {
      return true;
    }
    if (onlyCabrioletsSelected) {
      return car.isCabrio;
    }

    return filters[car.make] && (!filters["cabrio"] || car.isCabrio);
  });

  return (
    <main className="App">
      <ContextProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Menu />
                  <Welcome />
                  <Filter
                    filters={filters}
                    setFilters={setFilters}
                    carsLength={filteredCars.length}
                  />
                  <CarList cars={filteredCars} />
                  <Services />
                  <Reviews />
                  <ContactForm />
                </>
              }
            />
            <Route path="/car/:id" element={<Car />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </ContextProvider>
    </main>
  );
};
